export const formatCustomerAddress = (customer: any): string =>
  [
    customer.address_line_1,
    customer.address_line_2,
    customer.street,
    customer.city,
    customer.state,
    customer.country,
    customer.pin_code,
  ]
    .filter(Boolean)
    .join(", ");

export const ESTIMATION_TERMS: string[] = [
  "Price offered is inclusive of tax & in lieu of the defective spare/device (Under Exchange Price).",
  "100% advance payment along with order confirmation/purchase order.",
  "Replacement of spare part/device subject to checking & verification only.",
  "Replacement or repair is as per Apple’s stock availability (4-5 working days if in stock).",
  "The quoted price validity is subject to change depending on Apple price policy.",
  "Data must be backed up by the user; data is not covered under replacement.",
  "Replacement device will be same model/color/capacity but not box-packed (no accessories, scratch guards, etc.).",
  "For iOS device, price is for WUR (Whole Unit Replacement); if repairable, estimate will be shared.",
  "Device must be unlocked and 'Find My Device' turned off.",
  "90 days warranty on replaced part if device is out of warranty; otherwise, original warranty applies.",
  "Accidental damage voids warranty; exchange price will apply.",
  "Devices with alterations are not eligible for service under Apple policy.",
  "Diagnosis charges apply for out-of-warranty devices.",
  "Requests will be handled Mon–Sat, 10:30 am to 6:30 pm (excluding Sundays/national holidays)."
];
